import React from "react";
import { Link, useHistory } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import { connect } from "react-redux";
import { userSignOut } from "actions/auth";

const UserDropdown = ({ userAuth, userSignOut }) => {
    const history = useHistory();
    return (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
            <div className="py-1" role="menu" aria-orientation="vertical">
                <div className="px-4 py-2 border-b">
                    <p className="text-sm font-medium text-gray-900">
                        {userAuth.userAccount.preferred_name}
                    </p>
                    <p className="text-sm text-gray-500">
                        {userAuth.userAccount.email}
                    </p>
                </div>
                <Link
                    to="/dashboard"
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    role="menuitem"
                >
                    <User className="h-4 w-4 mr-2" />
                    Dashboard
                </Link>
                <button
                    onClick={() => userSignOut(history)}
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    role="menuitem"
                >
                    <LogOut className="h-4 w-4 mr-2" />
                    Sign Out
                </button>
            </div>
        </div>
    );
};

export default connect(null, { userSignOut })(UserDropdown);
